module.exports = __webpack_public_path__ + "img/z2.6fd57d8a.png";